<template>
  <div class="addFile">
    <div class="addCourse">
      <div class="title">
        <strong>{{title}}</strong>
      </div>
      <div class="formContent">
        <mt-field disabled v-model="ruleForm.roundsTitle" label="查房标题" placeholder="请输入" type="text"></mt-field>
        <!-- <mt-field disabled v-model="ruleForm.applyNote" style="border-bottom:1px solid #ccc;" label="申请说明" placeholder="请输入" type="textarea"></mt-field> -->
        <div class="text-area">
          <label for="bq">申请说明</label>
          <textarea id="bq" cols="35" rows="5" placeholder="请输入" v-model="ruleForm.applyNote" disabled></textarea>
        </div>
        <div class="select-wrapper">
          <p>
            <label for="hzHospital">查房医院:</label>
            <select disabled name="" id="hzHospital" class="hzHospital" placeholder="请输入" v-model="ruleForm.roundsHospital">
              <option value="" disabled selected hidden>请输入</option>
              <option v-for="(item, index) in roundsHospitalList" :value="item.id" :key="index">{{item.hospitalName}}</option>
            </select>
          </p>
          <p>
            <label for="hzHospital">查房医生:</label>
            <select name="" id="hzHospital" class="hzHospital" placeholder="请输入" v-model="ruleForm.roundsDoctor">
              <option value="" disabled selected hidden>请输入</option>
              <option :value="item.id" v-for="(item, index) in roundsDoctorList" :key="index">{{item.userName}}</option>
            </select>
          </p>
        </div>
        <!-- <mt-radio title="查房周期" :options="['单次', '每周', '每月']" v-model="ruleForm.roundsPeriod"></mt-radio> -->
        <div class="radioGroup">
          <span>查房周期</span>
          <div class="round-radio">
            <div class="radio-inline">
              <input v-model="ruleForm.roundsPeriod" id="dc" type="radio" name="roundsPeriod" value="单次" checked/>
              <label for="dc">单次</label>
            </div>
            <div class="radio-inline">
              <input v-model="ruleForm.roundsPeriod" id="mz" type="radio" name="roundsPeriod" value="每周" />
              <label for="mz">每周</label>
            </div>
            <div class="radio-inline">
              <input v-model="ruleForm.roundsPeriod" id="my" type="radio" name="roundsPeriod" value="每月" />
              <label for="my">每月</label>
            </div>
          </div>
        </div>
        <mt-field v-model="ruleForm.firstDate" style="ime-mode:disabled;display:inline-block;" label="首次日期" placeholder="请输入" type="datetime" @focus.native.capture="openData"></mt-field>
        <mt-datetime-picker
          ref="picker"
          type="datetime"
          v-model="pickerValue"
          @confirm="handleConfirm"
          :startDate="startDate">
        </mt-datetime-picker>
        <!-- <mt-radio title="是否同意" :options="['是', '否']" v-model="isAgree"></mt-radio> -->
        <div class="radioGroup">
          <span>是否同意</span>
          <div class="radio-inline">
            <input v-model="isAgree" id="ok" type="radio" name="isAgree" value="是" checked/>
            <label for="ok">是</label>
          </div>
          <div class="radio-inline">
            <input v-model="isAgree" id="cancel" type="radio" name="isAgree" value="否" />
            <label for="cancel">否</label>
          </div>
        </div>
        <p style="padding-left:2%;" class="reason-radio" v-if="isAgree == '否'">
          <label for="reasonRadio" class="reason-label">拒绝原因</label>
          <mt-checklist
            v-model="reasonRadio"
            @change="reasonRadioChange"
            id="reasonRadio"
            align="right"
            :options="['延期', '系统错误', '申请错误']">
          </mt-checklist>
        </p>
        <mt-field v-if="isAgree == '否'" label="拒绝原因" placeholder="请输入" v-model="ruleForm.reason"></mt-field>
        <!-- <p v-if="this.isAgree == '否'">
          <label style="padding-left:10px;">拒绝原因</label>
          <mt-button @click="handleRefuse(item)" type="default" size="small" v-for="(item, index) in refuse" :key="index">{{item}}</mt-button>
          <mt-button type="default" size="small">系统错误</mt-button>
          <mt-button type="default" size="small">申请错误</mt-button>
          <mt-field v-model="ruleForm.reason" label="拒绝原因" placeholder="请输入" type="text"></mt-field>
        </p> -->
        
        <div class="select-wrapper" v-if="this.isAgree == '是'">
          <p>
            <label for="hzHospital">会议室:</label>
            <select name="" id="hzHospital" class="hzHospital" placeholder="请输入" v-model="ruleForm.boardroom">
              <option value="" disabled selected hidden>请输入</option>
              <option v-for="(item, index) in conferenceRoomList" :value="item.hospitalId" :key="index">{{item.hospitalName}}</option>
            </select>
          </p>
        </div>
        <div style="text-align:right;padding:2%;">
          <mt-button type="default" size="small" @click="cancel">取消</mt-button>
          &emsp;
          <mt-button type="primary" size="small" @click="handleSubmit">确认</mt-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'mint-ui'
import { Indicator } from 'mint-ui'
import moment from 'moment'
import { MessageBox } from 'mint-ui'
export default {
  data() {
    return {
      reasonRadio: [],
      isAgree: '是',  //是否同意查房申请
      hospitalId: localStorage.getItem('HospitalID'), //当前登录医院的id
      topHospitalId: '',  //上级医院的id
      title: '',
      pickerValue: '',  //开始时间
      startDate: '',
      ruleForm: {
        roundsTitle: '',
        applyNote: '',  //申请说明
        roundsHospital: '',
        roundsDoctor: '', 
        roundsPeriod: '',  //查房周期
        firstDate: [],
        reason: '',
        boardroom: ''
      },
      roundsDoctorList: [],
      roundsHospitalList: [],
      conferenceRoomList: [], //会议室
      id: this.$route.query.id,
      type: this.$route.query.type
    }
  },
  created() {
    let curDate = new Date()
    // this.startDate = new Date(curDate.getTime() - 60*60*1000); //前一天
    this.startDate = new Date()
    this.arrange()
    this.getConferenceRoomList()
    this.title = '查房安排'
  },
  methods: {
    // 选择拒绝原因
    reasonRadioChange() {
      if (this.reasonRadio.length === 2) {
        this.reasonRadio.shift()
      }
      this.$set(this.ruleForm, 'reason', this.reasonRadio[0])
    },
    // handleRefuse(item) {
    //   this.$set(this.ruleForm, 'reason', item)
    // },
    // 获取所有会议室
    getConferenceRoomList() {
      this.Axios.get("/api/User/GetUserInfo").then(res=>{
        if(res.data.status===100){
          this.conferenceRoomList = res.data.ret.boardroom.value
        } else {
          Toast({
            message: '获取会议室失败!',
            position: 'top',
            duration: 1500
          });
        }
      })
    },
    
    // 安排 初始化数据
    arrange() {
      this.Axios.get("/api/Cooperative/GetCooperativeById?id="+this.id).then(res=>{
        const data = res.data
        if (data.status == 100) {
          if (data.data.roundsPeriod == 1) {
            data.data.roundsPeriod = '单次'
          } else if (data.data.roundsPeriod == 2) {
            data.data.roundsPeriod = '每周'
          } else {
            data.data.roundsPeriod = '每月'
          }
          data.data.firstDate = moment(data.data.firstDate).format('YYYY-MM-DD HH:mm')
          this.ruleForm = data.data
          this.roundsHospitalList.push({
            id: data.data.roundsHospital,
            hospitalName: data.data.hospitalName
          })
          this.getRoundDoctorList(data.data.roundsHospital)
        }
        
      }).catch(error=>{
        Toast({
          message: '内部错误请联系管理员',
          position: 'top',
          duration: 1500
        });
      })
    },
    // 同意安排
    agree(formData) {
      // 检查时间是否冲突
      this.Axios.get('/api/User/JudgeBoardroomInfo?time='+ formData.firstDate +'&boardroomId='+ formData.boardroom).then(res=>{
        // 时间冲突
        if (res.data.flag && res.data.status == 100) {
          MessageBox.confirm('会议时间段有冲突，是否继续？').then(()=>{
            this.Axios.put("/api/Cooperative/ArrangeCooperative?id="+this.ruleForm.id, formData).then(res=>{
              if (res.data.status===100) {
                Toast({
                  message: '安排成功!',
                  position: 'top',
                  duration: 1500
                });
                this.$router.push({
                  name: 'WardRound'
                })
              } else {
                Toast({
                  message: '添加瞩目会议室失败！会议室信息不正确，请联系管理员!',
                  position: 'top',
                  duration: 1500
                });
              } 
            }).catch(error=>{
              Toast({
                message: '网络错误请联系管理员!',
                position: 'top',
                duration: 1500
              });
            })
          }).catch(()=>{
            Toast({
              message: '已取消!',
              position: 'top',
              duration: 1500
            });
          })
        } else if (!res.data.flag && res.data.status == 100){
          this.Axios.put("/api/Cooperative/ArrangeCooperative?id="+this.ruleForm.id, formData).then(res=>{
            if(res.data.status===100){
              Toast({
                message: '安排成功!',
                position: 'top',
                duration: 1500
              });
              this.$router.push({
                name: 'WardRound'
              })
            }else{
              Toast({
                message: '添加瞩目会议室失败！会议室信息不正确，请联系管理员!',
                position: 'top',
                duration: 1500
              })
            }
          }).catch(error=>{
            Toast({
              message: '网络错误请联系管理员!',
              position: 'top',
              duration: 1500
            })
          })
        }else{
          Toast({
            message: '内部异常请联系管理员!',
            position: 'top',
            duration: 1500
          })
        }
      })
    },
    // 不同意安排
    notAgree(formData) {
      this.Axios.put("/api/Cooperative/ArrangeCooperative?id="+this.ruleForm.id, formData).then(res=>{
        if (res.data.status == 100) {
          Toast({
            message: '操作成功!',
            position: 'top',
            duration: 1500
          });
          this.$router.push({
            name: 'WardRound'
          })
        } else {
          Toast({
            message: '添加瞩目会议室失败！会议室信息不正确，请联系管理员!',
            position: 'top',
            duration: 1500
          });
        }
      }).catch(error=>{
        Toast({
          message: '网络错误请联系管理员!',
          position: 'top',
          duration: 1500
        });
      })
    },
    // 执行安排查房
    doArrange() {
      let formData = {}
      formData.roundsTitle = this.ruleForm.roundsTitle
      formData.applyNote = this.ruleForm.applyNote
      formData.roundsHospital = this.ruleForm.roundsHospital
      formData.roundsDoctor = this.ruleForm.roundsDoctor
      formData.firstDate = this.ruleForm.firstDate
      formData.boardroom = this.ruleForm.boardroom
      if (this.ruleForm.roundsPeriod == '单次') {
        formData.roundsPeriod = 1
      } else if (this.ruleForm.roundsPeriod == '每周') {
        formData.roundsPeriod = 2
      } else {
        formData.roundsPeriod = 3
      }
      for (let item in formData) {
        if (formData[item] == '') {
          Toast({
            message: '请把数据补充完整!',
            position: 'top',
            duration: 1500
          });
          return
        }
      }
      // 同意安排
      if (this.isAgree == '是') {
        formData.isAgree = true
        this.agree(formData)
      } else {
        formData.isAgree = false
        formData.reason = this.ruleForm.reason
        this.notAgree(formData)
      }
    },
    handleSubmit() {
      this.doArrange()
    },  
    // 打开日期选择器
    openData() {
      this.$refs.picker.open()
      document.activeElement.blur()
    },
    // 选择时间
    handleConfirm() {
      this.ruleForm.firstDate = this.pickerValue
      this.ruleForm.firstDate = moment(this.pickerValue).format('YYYY-MM-DD HH:mm')
    },
    // 获取查房医生
    getRoundDoctorList(topHospitalId) {
      this.Axios.get('/api/Hospital/GetDoctorByHId?hospitalId=' + topHospitalId).then(res => {
        if(res.data.status===100){
          this.roundsDoctorList = res.data.data
          // this.ruleForm.roundDoctor = res.data.data[0].id
        } else {
          Toast({
            message: '当前查房医院下没有医生!',
            position: 'top',
            duration: 1500
          });
        }
      }).catch(error=>{
        this.$message({
          showClose: true,
          message: '网络错误，联系管理员',
          type: 'error'
        });
      })
    },
    
    cancel() {
      this.$router.push({
        name: 'WardRound'
      })
    }
  }
}
</script>

<style lang="less">
.addFile {
  height: 99%;
  background: white;
  // border: 1px solid rebeccapurple;
  overflow: auto;
  // border: 1px solid rebeccapurple;
  .addCourse {
    height: 100%;
    // border: 1px solid rebeccapurple;
    .title {
      font-size: 14px;
      height: 3%;
      padding: 2% 2%;
      border-top: 1px solid #eee;
      border-bottom: 1px solid #eee;
      background: #f5f5f9;
    }
    .formContent {
      .radioGroup {
        height: 24px !important;
        line-height: 24px !important;
        padding: 0 10px;
        // border-top: 1px dotted #ccc;
        // border-bottom: 1px dotted #ccc;
        span {
          width: 105px !important;
          display: block;
          float: left;
        }
        .radio-inline {
          float: left;
          margin-right: 10px;
          line-height: 24px;
          input[type="radio"] + label::before {
            content: "\a0";
            display: inline-block;
            vertical-align: middle;
            width: 10px;
            height: 10px;
            margin-right: 5px;
            border-radius: 50%;
            text-indent: .15em;
            margin-bottom: 4px;
            border: 1px solid #CCCCCC;
            padding: 2px;
          }
          input[type="radio"] {
            position: absolute;
            clip: rect(0, 0, 0, 0);
          }
          input[type="radio"]:checked + label::before {
            background-color: #4A90E2;
            background-clip: content-box;
            padding: 2px;
          }
        }
        .round-radio {
          float: left;
        }
      }
      .text-area {
        padding-left: 10px;
        padding-right: 10px !important;
        margin-top: 16px;
        display: flex;
        &::after {
          content: "";
          display: block;
          width: 0;
          height: 0;
          clear: both;
        }
        textarea {
          outline: none;
          flex: 1;
          border: 1px solid #ccc;
          float: right;
        }
        label {
          display: block;
          width: 105px;
          // border: 1px solid rebeccapurple;
          float: left;
          top: 0;
        }
      }
      .select-wrapper {
        padding-left: 2%;
        label {
          display: inline-block;
          width: 105px;
        }
        .hzHospital{
          background: rgba(0,0,0,0);
          width: 55%;
          height: 32px;
          font-family: "微软雅黑";
          font-size: 14px !important;
          color: #aaa !important;
          border: 1px #ccc solid;
          border-radius: 5px;
          margin-left: 0 !important;
          outline: none;
          &:focus{
            border: 1px #ddd solid;
            box-shadow: 0 0 15px 1px #DDDDDD;
          }
          option{
            color: black !important;
            background: white;
            line-height: 20px;
            // &:hover{
            //   background: #EBCCD1;
            // }
          }
        }
        .hys {
          display: inline-block;
          margin-right: 4%;
        }
      }
      .userGroup {
        padding-left: 3%;
        span {
          display: inline-block;
          margin-right: 3%;
        }
      }
      .reason-radio {
        padding-left: 2%;
        .reason-label {
          display: inline-block;
          width: 105px;
        }
        .mint-radiolist-title {
          display: none;
        }
        .mint-cell {
          min-height: 36px;
        }
      }
    }
  }
  input::-webkit-input-placeholder, textarea::-webkit-input-placeholder, select {
    font-weight: 400 !important;
    color: rgb(102, 102, 102) !important;
    font-size: 14px !important;
    font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
  }
  input::-moz-placeholder, textarea::-moz-placeholder {
    font-weight: 400 !important;
    color: rgb(102, 102, 102) !important;
    font-size: 14px !important;
    font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
  }
  input::-ms-input-placeholder, textarea::-ms-input-placeholder {
    font-weight: 400 !important;
    color: rgb(102, 102, 102) !important;
    font-size: 14px !important;
    font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
  }
}
</style>
